import { CONSTANT } from '@/store/constants';
import { publicClient } from './client';

const pollingInterval = 4e3;
  // --url 'https://developer.world.org/api/v2/minikit/transaction/{transaction_id}?type=transaction&app_id=app_60c094705c114bff41be480e736d9482'
async function fetchTransactionHash(transactionId: string) {
  try {
    const response = await fetch(
      `https://developer.world.org/api/v2/minikit/transaction/${transactionId}?app_id=${CONSTANT.APP_ID}&type=transaction`,
      {
        method: 'GET',
      }
    );
    console.log('Received response:', response.url);
    if (!response.ok) {
      throw new Error('Failed to fetch transaction status');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.log('Error fetching transaction status', error);
    throw new Error('Failed to fetch transaction status');
  }
}

export async function fetchStatus(
  transactionId: string
): Promise<{ transactionHash: string }> {
  return await fetchTransactionHash(transactionId);
}

export async function waitForTransactionReceipt(
  transaction_id: string
): Promise<string> {
  return new Promise((resolve, reject) => {
    const pollHash = async () => {
      try {
        const status = await fetchStatus(transaction_id);

        console.debug('status.transactionHash', status.transactionHash);

        if (status.transactionHash) {
          const transaction = await publicClient.waitForTransactionReceipt({
            hash: status.transactionHash as `0x${string}`,
          });
          console.log('Transaction receipt:', transaction);
          resolve(transaction.transactionHash);
        } else {
          setTimeout(pollHash, pollingInterval);
        }
      } catch (error) {
        console.error('Error during polling:', error);
        reject(error);
      }
    };

    pollHash();
  });
}
